import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Crayons ... best productivity hack ever?",
  "description": "",
  "published": "2011-07-21T00:00:00.000Z",
  "redirect_from": ["/blog/crayons-best-productivity-hack-ever/swizec/1982"],
  "categories": "Crayon, List of artistic media, Paint, Pastel, Pencil, Uncategorized, Visual Arts, Wax",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Two days ago I complained about not being able to `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-learned-two-things-today/swizec/1956",
        "title": "I learned two things today"
      }}>{`brainstorm under the shower`}</a>{` because there is nowhere to jot down my thoughts ... I tend to think a lot better when I can scribble somewhere.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/IJWfg-300x300.jpg",
        "alt": null,
        "title": "Crayon+moleskin+mac"
      }}></img></p>
    <p>{`Quite a few of you suggested I use something called a "`}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Grease_pencil",
        "title": "Grease pencil"
      }}>{`wax pencil`}</a>{`".`}</p>
    <p>{`Yesterday I visited a nearby `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/List_of_artistic_media",
        "title": "List of artistic media"
      }}>{`art supply`}</a>{` store, `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps/place?q=Accent+Arts,+South+California+Avenue,+Palo+Alto,+CA&hl=en&cid=5872990577141797841"
      }}>{`Accent Arts`}</a>{`. Don't think I've ever seen an art store stocked so well!`}</p>
    <p>{`They didn't know what a wax pencil was.`}</p>
    <p>{`After explaining that my purpose in life is the magical ability to write on a wet `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Glazed_tile",
        "title": "Glazed tile"
      }}>{`glazed tile`}</a>{` and be able to easily erase everything after I'm done, they suggested I try two things.`}</p>
    <p>{`A `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Solubility",
        "title": "Solubility"
      }}>{`water soluble`}</a>{` `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Wax",
        "title": "Wax"
      }}>{`wax`}</a>{` `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Pastel",
        "title": "Pastel"
      }}>{`pastel`}</a>{` and a water soluble oil pastel.`}</p>
    <p>{`They had another suggestion, but it was made of wood so it didn't look like a very natural fit.`}</p>
    <p>{`I got home with a `}<em parentName="p">{`crayon`}</em>{` and an oil pastel. Yes, the wax pencil slash wax pastel calls itself a crayon. One of those things I last saw in kindergarten and forgot even existed.`}</p>
    <p>{`The oil pastel didn't work out too well. It's too hard and doesn't write on smooth surfaces, then when you do manage to leave a mark it's damn near impossible to erase.`}</p>
    <p>{`True story.`}</p>
    <p>{`But the crayon!`}</p>
    <p>{`I. Am. In. Love!`}</p>
    <p>{`Seriously, I'm never leaving home without a crayon somewhere on my person ever again. It's pretty much the single most perfect tool for impromptu thinking. Soft enough to write on pretty much any smooth surface. Erasable with ease.`}</p>
    <p>{`Yes, it even works under the shower despite a few problems with washing off soon after writing ... but that just makes you focus more. It doesn't wash off enough to vanish, but isn't a perfect replacement for your memory either.`}</p>
    <p>{`Just the perfect balance.`}</p>
    <p>{`I also have a feeling this would work perfectly for, say, writing on tables at coffee shops, windows on a train ... everywhere. Glass is seriously everywhere!`}</p>
    <p>{`It actually works -->`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/11f3ebb3ac804d4182fc72487e333a56_7.jpeg",
        "alt": null,
        "title": "Under the shower"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/16c0f3efb66f42f8972bdecd18a37c07_7.jpeg",
        "alt": null,
        "title": "Writing on a glass door, night"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/009d0c8621ad402fb7a5c1ea3efc429d_7.jpeg",
        "alt": null,
        "title": "Glass door, day"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://andsewitgoes.org/2011/06/29/crayon-pencil-rolls/"
        }}>{`Crayon & Pencil Rolls`}</a>{` (andsewitgoes.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://itsasmallweb.wordpress.com/2011/06/20/made-of-crayons/"
        }}>{`Made of crayons`}</a>{` (itsasmallweb.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://annstephensromance.com/2011/07/19/my-not-so-secret-habit/"
        }}>{`My Not-So-Secret Habit`}</a>{` (annstephensromance.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=5cd4c539-e71b-484d-b088-58ecb0a46622",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      